import {SolidRectangle} from './shapes/SolidRectangle';
import {RoiHandlerFixedWidth} from './RoiHandlerFixedWidth';
import {RoiHandlerResizable} from './RoiHandlerResizable';
// Removed in 12.4. Will restore in Mustang.
// import {RoiHandlerFixedAspect} from './RoiHandlerFixedAspect';
import {RoiHandlerWysiwyg} from './RoiHandlerWysiwyg';
import {DrawingSurface} from './DrawingSurface';
import {SolidBackground} from './shapes/SolidBackground';
import {MODES, CSS_CLASS_NAMES, SNAPSHOT_DRAW_BACKGROUND_COLOR, ANIMATE_SPEED} from '../settings/constants';
import b64 from '../assets/b64-data.json';

export function animateArea (surface, area) {
  return new Promise((resolve) => {
    let delta = ANIMATE_SPEED.ASCENDING;
    const r = new SolidRectangle(area.x, area.y, area.w, area.h, {opacity: 0});
    const animator = {
      draw (surface) {
        if (r.opacity < 0) {
          // When we're done we're done.
          return;
        }

        // Draw the rectangle.
        r.draw(surface);

        // Increment the opacity.
        r.opacity += delta;

        // Switch directions when we peak.
        if (r.opacity >= 1 && delta === ANIMATE_SPEED.ASCENDING) {
          delta = ANIMATE_SPEED.DESCENDING;
        }

        // Flag the surface to redraw on the next paint cycle.
        setTimeout(() => { surface.valid = false; });

        // Let people know when we're done.
        if (r.opacity <= 0) {
          resolve();
        }
      }
    };

    surface.removeAllShapes();
    surface.addShape(animator);
  });
}

export function playShutterSound () {
  const source = 'shutter.mp3';
  const data = b64[source];
  const audio = new Audio(`data:${data.mimeType};${data.encoding},${data.payload}`);
  audio.play();
}

export function createCanvas (viewportElement, settings) {
  const canvas = document.createElement('canvas');

  // Style the canvas
  canvas.className = CSS_CLASS_NAMES.CANVAS_BASE_CLASS;
  canvas.classList.add(`mode-${settings.mode}`);
  canvas.height = viewportElement.offsetHeight;
  canvas.width = viewportElement.offsetWidth;

  // Put the canvas on the viewport div.
  viewportElement.appendChild(canvas);

  return canvas;
}

export function createDrawingSurface (renderer, canvas, viewportElement) {
  const surface = new DrawingSurface(canvas, viewportElement);
  surface.addShape(new SolidBackground(SNAPSHOT_DRAW_BACKGROUND_COLOR));
  renderer.addSurface(surface);

  return surface;
}

const roiModeLookupTable = {
  [MODES.FIXED]: RoiHandlerFixedWidth,
  // Removed in 12.4. Will restore in Mustang.
  // [MODES.FIXED_ASPECT]: RoiHandlerFixedAspect,
  [MODES.RESIZABLE]: RoiHandlerResizable,
  [MODES.WYSIWYG]: RoiHandlerWysiwyg
};

export function createRoiHandler (eventChannel, viewport, settings) {
  return new roiModeLookupTable[settings.mode](eventChannel, viewport, settings);
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/drawing/roi-helper-methods.js